'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupedSearchButton = function GroupedSearchButton(_ref) {
  var currentView = _ref.currentView,
      toggleListView = _ref.toggleListView,
      className = _ref.className;

  var isActive = currentView === 'grouped' ? 'active' : '';
  var toggleView = function toggleView() {
    return toggleListView('grouped');
  };
  var btnClasses = (0, _classnames2.default)('cp-group-search-button', className, {
    active: currentView === 'grouped'
  });

  return _react2.default.createElement(
    _reactIntl.FormattedMessage,
    { id: 'grouped_view', values: { isActive: isActive ? 'yes' : 'no' } },
    function (message) {
      return _react2.default.createElement(
        _baseButtons.DefaultButton,
        { 'data-test-id': 'grouped-search-button', className: btnClasses, flat: true, handleClick: toggleView, title: message },
        _react2.default.createElement(_baseIcons.GroupedView, null),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          message
        )
      );
    }
  );
};

GroupedSearchButton.propTypes = {
  className: _react.PropTypes.string,
  currentView: _react.PropTypes.string,
  toggleListView: _react.PropTypes.func.isRequired
};

exports.default = GroupedSearchButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-grouped-search-button/lib/components/GroupedSearchButton.component.js
// module id = 1080
// module chunks = 1